import { parse } from 'query-string'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Types from './types'
import * as Utils from './utils'

const defaultState: Types.PageState = {
  pageNumber: 1,
  skip: 0,
  take: 50,
}

type ReducerActions = Router.OnEnterAction & Actions.ChangePageAction & Actions.PaginationAction
export const createReducer = (prefix: string, initialState: Types.PageState = defaultState) =>
  (state: Types.PageState = initialState, action: ReducerActions) => {
    switch (action.type) {
      case Router.ON_ENTER:
      case Utils.initializePageConstant(prefix):
        return {
          pageNumber: (Number(parse(action.routerContext.search).pageNumber) || initialState.pageNumber),
          skip: initialState.skip,
          take: initialState.take,
        }
      case Utils.goToPageConstant(prefix):
        return {
          ...state,
          pageNumber: action.pageNumber,
        }
      case Utils.changePageConstant(prefix):
        return {
          ...state,
          pageNumber: action.pageChange.pageNumber,
          skip: action.pageChange.skip,
          take: action.pageChange.take,
        }
      default:
        return state
    }
  }



// WEBPACK FOOTER //
// ./src/components/pager/reducer.ts